// #redesign Welle A — relative Zeit ("vor 5s", "vor 3min") für Heartbeat/lastSeen.
// Snapshot beim Render; Live-Polling (#10) hält die Werte frisch.
export function relativeTime(iso: string | null | undefined): string {
  if (!iso) return "nie";
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return "—";
  // Math.floor pro Stufe: sonst rollt z.B. 59.5min via round zu "vor 1h". floor(neg) < 5
  // fängt auch Uhr-Drift (Zukunft) → "gerade eben".
  const s = Math.floor((Date.now() - then) / 1000);
  if (s < 5) return "gerade eben";
  if (s < 60) return `vor ${s}s`;
  const m = Math.floor(s / 60);
  if (m < 60) return `vor ${m}min`;
  const h = Math.floor(m / 60);
  if (h < 24) return `vor ${h}h`;
  const d = Math.floor(h / 24);
  return `vor ${d}d`;
}

// Frische-Klassifikation für Heartbeat-Health. true = innerhalb maxAgeSec gesehen.
export function isFresh(iso: string | null | undefined, maxAgeSec = 90): boolean {
  if (!iso) return false;
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return false;
  return (Date.now() - then) / 1000 <= maxAgeSec;
}
